export default __webpack_public_path__ + "static/media/(96).9903ebd0.jpg";